import React from "react";
import "./ProjectComplete.css";
import "components/General/Video/Video.css";
import { Player } from "video-react";
import AxiosConfig from "axiosConfig";
import Image from "react-bootstrap/Image";

/**
 * @description Creates a summary of the spreading the word as part of the challenge
 * @class SpreadTheWordSummary
 * @implements none
 * @extends React.Component
 * @type {SpreadTheWordSummary}
 * @example <SpreadTheWordSummary />
 * pre-condition: all the imports
 * post-condition: returns a form with all the information about spreading the word about the project
 * @param invitees, video
 * @returns {SpreadTheWordSummary}
 */

class SpreadTheWordSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invitees: [],
      video: "",
    };
  }
  componentDidMount() {
    let formData = new FormData();
    formData.append("adventure", undefined);
    AxiosConfig.get(
      `/impactprojects/Congratulations/${this.props.projectSlug}/${this.props.projectUserId}`,
      formData
    )
      .then((res) => {
        this.setState({
          invitees: res.data.invitees,
          video: res.data.video?res.data.video:this.props.video,
        });
      })
      .catch();
  }
  render() {
    const url = this.state.video;
    return (
      <div className="challenge-form">
        <div className="challenge-form-inner">
          <label className="statement">
            I reached my project goal of {this.props.challengeName} by inviting
            the following friends to the project:
          </label>
          <ul>
            {this.state.invitees
              ? this.state.invitees.map((item) => (
                  <li>
                    <label>{item}</label>
                  </li>
                ))
              : null}
          </ul>
          <div
            className="project-video-preview"
            style={{ width: this.props.width }}
          >
            {url.match(/\.(jpeg|jpg|gif|png|JPG|JPEG|PNG)$/) != null ? (
              <Image src={url} className="w-100" />
            ) : (
              <Player
                className="video-upload-preview"
                fluid={false}
                playsInline
                src={url}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default SpreadTheWordSummary;
